import React from 'react';

import classNames from 'classnames';

import IntlMessages from '@src/util/IntlMessages';

import type { AttendanceKpis } from '../../utils/attendanceStatus/types';
import {
  REAL_TIME_KPI_FILTERS,
  type RealTimeKpiKey,
} from '../../utils/realTimeKpiFilters';
import styles from './WorkJourneyRealTimeKpiCards.module.less';

interface WorkJourneyRealTimeKpiCardsProps {
  kpis: AttendanceKpis;
  activeKpiKey: RealTimeKpiKey | null;
  onSelectKpi: (key: RealTimeKpiKey) => void;
}

interface KpiCardProps {
  kpiKey: RealTimeKpiKey;
  value: number;
  labelId: string;
  tone?: 'default' | 'danger';
  isActive: boolean;
  onSelectKpi: (key: RealTimeKpiKey) => void;
}

const KpiCard = React.memo(
  ({ kpiKey, value, labelId, tone = 'default', isActive, onSelectKpi }: KpiCardProps) => (
    <button
      type="button"
      className={classNames(
        styles.card,
        tone === 'danger' && styles.danger,
        isActive && styles.active,
      )}
      aria-pressed={isActive}
      onClick={() => onSelectKpi(kpiKey)}
    >
      <span className={classNames(styles.value, tone === 'danger' && styles.dangerValue)}>
        {value}
      </span>
      <span className={classNames(styles.label, tone === 'danger' && styles.dangerLabel)}>
        <IntlMessages id={labelId} />
      </span>
    </button>
  ),
);

const WorkJourneyRealTimeKpiCards: React.FC<WorkJourneyRealTimeKpiCardsProps> = ({
  kpis,
  activeKpiKey,
  onSelectKpi,
}) => (
  <div className={styles.root}>
    {REAL_TIME_KPI_FILTERS.map(({ key, kpiField, labelId, tone }) => (
      <KpiCard
        key={key}
        kpiKey={key}
        value={kpis[kpiField]}
        labelId={labelId}
        tone={tone}
        isActive={activeKpiKey === key}
        onSelectKpi={onSelectKpi}
      />
    ))}
  </div>
);

export default React.memo(WorkJourneyRealTimeKpiCards);
